import { TabWrap } from 'sections/TabWrap';

import { useBillingAddress } from './BillingAddress.hooks';

export function BillingAddress(): React.ReactElement {
  const { sections } = useBillingAddress();

  return <TabWrap sections={sections} />;
}
